import { useEffect } from "react";

interface UseAlertClickOutsideParams {
  ref: React.RefObject<HTMLDivElement>;
  onOutsideClick: (event: MouseEvent) => Promise<void>;
}

export function useAlertClickOutside({
  ref,
  onOutsideClick
}: UseAlertClickOutsideParams) {
  useEffect(() => {
    async function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClick(event);
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [onOutsideClick, ref]);
}
